/**
 * Values for the `source` query param on referral details routes and on
 * `GET /referral/currentuser/:id`. Must stay aligned with the backend
 * `ReferralController` query enum.
 */
export const REFERRAL_SOURCE_QUERY_PARAM = 'source';

export const REFERRAL_SOURCE_EXTERNAL = 'external';
